import { Chip, ChipProps, IconButton, useTheme } from "@mui/material";
import React from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";

interface Props {
  onClick: (e: any) => void;
  chipProps?: ChipProps;
}

export const ClearFilterButton = ({ onClick, chipProps }: Props) => {
  const theme = useTheme();

  return (
    <Chip
      disabled={false}
      size={"medium"}
      clickable
      variant={"outlined"}
      color={"default"}
      label={"Clear Filters"}
      onClick={onClick}
      sx={{
        transition: "all 0.3s ease",
        backgroundColor: theme.palette.grey[200],
      }}
      {...chipProps}
    />
  );
};
